var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSortAsc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9371 10.0923C15.8121 10.3394 15.5217 10.5 15.2 10.5H8.80002C8.47829 10.5 8.18787 10.3394 8.06287 10.0923C7.93787 9.84531 8.00262 9.55989 8.22722 9.36793C9.23976 8.50355 10.2353 7.62392 11.2912 6.79578C11.4907 6.63932 11.7114 6.5 12 6.5C12.2886 6.5 12.5093 6.63932 12.7088 6.79578C13.7634 7.62296 14.7606 8.5039 15.7722 9.36742C15.9968 9.55938 16.0621 9.84531 15.9371 10.0923Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9372 13.9077C15.8122 13.6606 15.5217 13.5 15.2 13.5H8.80004C8.47831 13.5 8.18789 13.6606 8.06289 13.9077C7.93789 14.1547 8.00264 14.4401 8.22724 14.6321C9.23978 15.4964 10.2354 16.3761 11.2913 17.2042C11.4908 17.3607 11.7114 17.5 12 17.5C12.2886 17.5 12.5093 17.3607 12.7088 17.2042C13.7635 16.377 14.7607 15.4961 15.7722 14.6326L15.7728 14.6321C15.9974 14.4401 16.0621 14.1547 15.9372 13.9077Z",
    fill: "#263238"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortAsc);
export default __webpack_public_path__ + "static/media/SortAsc.f983af3a49927978397d708a4df74f04.svg";
export { ForwardRef as ReactComponent };